import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { parseISO } from 'date-fns';

import { Card, CardTitle } from 'components/Card';
import Message from 'components/Message';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import { makePath } from 'helpers/link-generation';
import './AccountInformationSection.scss';
import When from 'components/When';

const messages = defineMessages({
  accountInformationLabel: {
    id: 'settings.account-information-section.account-information-label',
    defaultMessage: 'Account information',
  },
  emailAddressLabel: {
    id: 'settings.account-information-section.email-address-label',
    defaultMessage: 'Email address',
  },
  nameLabel: {
    id: 'settings.account-information-section.name-label',
    defaultMessage: 'Name',
  },
  memberSinceLabel: {
    id: 'settings.account-information-section.member-since-label',
    defaultMessage: 'Partner since',
  },
  emailStatusMessageNotBouncing: {
    id: 'settings.account-information-section.email-status-message-not-bouncing',
    defaultMessage: 'Status: Active',
  },
  emailStatusMessageBouncing: {
    id: 'settings.account-information-section.email-status-message-bouncing',
    defaultMessage: 'Status: Bouncing, please <a>Contact Us</a> to resolve',
  },
});

const AccountInformationSection = ({
  user: { email, firstName, lastName, dateJoined },
  brazeEmailIsBounced,
  venueId,
  locale,
}) => {
  return (
    <Card>
      <Message as={CardTitle} message={messages.accountInformationLabel} />

      <div className="grid">
        <div className="grid__item sm-1/2">
          <Message as="div" className="text--light" message={messages.nameLabel} />
          {`${firstName} ${lastName}`}
        </div>

        {dateJoined && (
          <div className="grid__item sm-1/2 mt-r md-mt-0">
            <Message as="div" className="text--light" message={messages.memberSinceLabel} />
            <Message value={parseISO(dateJoined)} format="short" />
          </div>
        )}

        <div className="grid__item sm-1/2 mt-r">
          <Message as="div" className="text--light" message={messages.emailAddressLabel} />
          {email}
          <div className="status-icon">
            <When predicate={brazeEmailIsBounced}>
              <Isvg className="warning-icon" src={ICONS.warningYellow} />
              <Message
                message={messages.emailStatusMessageBouncing}
                values={{
                  a: text => <a href={makePath.contactUs(venueId, locale)}>{text}</a>,
                }}
              />
            </When>
            <When predicate={!brazeEmailIsBounced}>
              <Isvg className="green-check-icon" src={ICONS.success} />
              <Message className="status-message" message={messages.emailStatusMessageNotBouncing} />
            </When>
          </div>
        </div>
      </div>
    </Card>
  );
};

AccountInformationSection.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    dateJoined: PropTypes.string,
  }),
  brazeEmailIsBounced: PropTypes.bool,
  venueId: PropTypes.number,
  locale: PropTypes.string,
};

export default AccountInformationSection;
